import styles from "./custom-datepicker.module.css";
import { DatePicker, Input, Typography } from "antd";

const { Text } = Typography;
export function CustomDatepicker({
  id,
  label,
  value,
  onChange,
  placeholder,
  size = "small",
  variant = "outlined",
  nextIcon = null,
  allowClear,
  defaultValue,
  disabled,
  disabledDate,
  status,
  format = "DD-MM-YYYY",
  className,
  minDate,
  maxDate,
  labelColor = "#000",
  style = { width: "100%" },
  errorMessage,
  prefix,
  suffixIcon = null,
  picker = "date",
  showRequired = false,
  showOptional = false,
}) {
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <div>
      <div style={{ marginBottom: 8, fontWeight: 400, color: labelColor }}>
        {label}
        {showRequired ? (
            <span style={{ color: "red" }}>*</span>
          ) : showOptional ? (
            <span  style={{ color: "#8C8C8C" }}>
              {typeof showOptional === "string" ? ` ${showOptional}` : " (Optional)"}
            </span>
          ) : null}
      </div>
      <DatePicker
        id={id}
        format={format}
        placeholder={placeholder}
        size={size}
        value={value}
        variant={variant}
        allowClear={allowClear}
        defaultValue={defaultValue}
        status={status}
        disabled={disabled}
        disabledDate={disabledDate}
        minDate={minDate}
        maxDate={maxDate}
        className={className}
        suffixIcon={suffixIcon}
        picker={picker}
        prefix={prefix}
        style={style}
        onChange={onChange}
      />
      <Text type="danger" style={{ marginTop: 5 }}>
        {errorMessage}
      </Text>
    </div>
  );
}

export default CustomDatepicker;
